import { API_BASE_URL } from '../config/api';

const sessionHeader = headers => {
  if (typeof headers?.get === 'function') return headers.get('session-id');
  const entries = Array.isArray(headers) ? headers : Object.entries(headers || {});
  return entries.find(([name]) => name.toLowerCase() === 'session-id')?.[1];
};

const isBackendRequest = input => {
  try {
    const url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, window.location.href);
    const api = new URL(API_BASE_URL, window.location.href);
    const path = api.pathname.replace(/\/$/, '');
    return url.origin === api.origin && (url.pathname === path || url.pathname.startsWith(`${path}/`));
  } catch { return false; }
};

export const observeSessionFailures = onInvalidSession => {
  const originalFetch = window.fetch;
  let active = true;
  const observedFetch = async (input, options) => {
    const token = sessionHeader(options?.headers ?? input?.headers);
    const authenticated = !!token && isBackendRequest(input);
    const response = await originalFetch.call(window, input, options);
    if (!active || !authenticated) return response;
    let invalid = response.status === 401;
    if (!invalid && [400, 403].includes(response.status)) {
      try {
        const data = await response.clone().json();
        invalid = ['INVALID_SESSION', 'SESSION_EXPIRED', 'SESSION_NOT_FOUND'].includes(data?.code)
          || /\b(?:invalid|expired)\s+session\b|\bsession(?:\s+id)?\s+(?:(?:is|has)\s+)?(?:invalid|expired|not found)\b/i.test(String(data?.error || data?.message || ''));
      } catch {}
    }
    if (active && invalid) onInvalidSession(String(token));
    return response;
  };
  window.fetch = observedFetch;
  return () => {
    active = false;
    if (window.fetch === observedFetch) window.fetch = originalFetch;
  };
};